import * as app from "./subsystems/app/actions";
import * as clients from "./subsystems/clients/actions";
import { actions as user } from "@lifepay/redux-subsystem-user";
const actions = {
  app,
  user,
  clients,
};

export default actions;



// WEBPACK FOOTER //
// ./src/model/actions.js